import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[slug]/DynamicPageClient.tsx");
